// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blocked-cities__text[data-v-4ce310ff] {\n  margin-top: 15px;\n}\n.blocked-cities__select[data-v-4ce310ff] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
